import { localStorageAdapter } from './storage';
export const STORAGE_KEY = '__trackingOptInStatus';
export const SCRIPT_NAME = '__toi';
export enum OPTIN_STATUS {
    /** Consent has not yet been given or has been reset */
    UNSPECIFIED = 0,
    /** Consent has been granted */
    GRANTED = 1,
    /** Consent has been denied */
    DENIED = -1,
}

/** Wrapper to export a mutable object */
export const storageAdapter = {
    instance: localStorageAdapter(),
};

/** Retrieves the current configuration from the storage adapter */
export const loadConfiguration = (): Record<string, OPTIN_STATUS> =>
    JSON.parse(storageAdapter.instance.get(STORAGE_KEY) || '{}') || {};

/**
 * @param serviceId ID of a {@link TrackingOptInService}
 * @returns The consent status for this service or
 *      {@link OPTIN_STATUS.UNSPECIFIED} if not yet specified.
 */
export const getServiceStatus = (serviceId: string): OPTIN_STATUS =>
    loadConfiguration()[serviceId] || OPTIN_STATUS.UNSPECIFIED;
